import React, { useState} from 'react'; // ADD useCallback here
import { memo } from 'react';
import DeckHeader from './DeckHeader/DeckHeader.jsx';
import DeckTable from './DeckTable/DeckTable.jsx';
import ThreeScene from './DeckScene/ThreeScene.jsx';
import DeckSize from './DeckSideBar/DeckSize/DeckSize.jsx';
import ArrangementParameters from './DeckSideBar/ArrangementParameters/ArrangementParameters.jsx';
import Dashboard from './Dashboard/Dashboard.jsx';
import './Deck.css';
// import { arrangeSnakeAlgorithm } from '../Api/Api.jsx';
import LayerVisibility from './DeckSideBar/LayerVisibility/LayerVisibility.jsx';
import CameraManager from './DeckSideBar/CameraManager/CameraManager.jsx';

// Memoize expensive child components
const MemoizedThreeScene = memo(ThreeScene);
const MemoizedDeckTable = memo(DeckTable);

function Deck() {
  const [cargos, setCargos] = useState([]);
  const [cargoArea, setCargoArea] = useState([]);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [activePage, setActivePage] = useState('arrangement');
  const [isCreated, setIsCreated] = useState(false);
  const [messages, setMessages] = useState([]);
  const [arrangeParameters, setArrangeParameters] = useState({
    startCorner: 0,
    arrangementDirection: "x",
    rowDirection: true,
    arrangementOptions: 0
  });  

  // States for camera management
  const [camera, setCamera] = useState(null);
  const [controls, setControls] = useState(null);

  console.log('Parent component cargos:', cargos);

  // Function to add messages
  const addMessage = (text, type = 'info') => {
    const newMessage = {
      id: Date.now(),
      text,
      type
    };
    setMessages(prev => [...prev, newMessage]);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      removeMessage(newMessage.id);
    }, 5000);
  };

  // Function to remove messages
  const removeMessage = (id) => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  };

  // Instead of useCallback, use regular functions:
  const handleCameraReady = (camera) => {
    console.log('📷 Camera ready in parent:', camera);
    setCamera(camera);
  };

  const handleControlsReady = (controls) => {
    console.log('🎮 Controls ready in parent:', controls);
    setControls(controls);
  };

  const handleDashboardAction = (action, data) => {
    console.log('Dashboard action:', action, data);
    switch (action) {
      case 'arrangeAll':
        addMessage('Arranging all cargos...', 'info');
        break;
      case 'exportData':
        addMessage('Data exported successfully!', 'success');
        break;
      case 'clearAll':
        setCargos([]);
        addMessage('All cargos cleared', 'warning');
        break;
      case 'optimizeLayout':
        addMessage('Optimizing layout...', 'info');
        break;
      default:
        addMessage('Unknown action performed', 'error');
        console.log('Unknown action:', action);
    }
  };

  const handlePageChange = (pageId) => {
    console.log('Changing page to:', pageId);
    setActivePage(pageId);
  };

  // Message Bar Component
  const MessageBar = () => {
    if (messages.length === 0) return null;
    
    return (
      <div className="message-bar-overlay">
        {messages.map(message => (
          <div 
            key={message.id} 
            className={`message-bar-item message-${message.type}`}
          >
            <span>{message.text}</span>
            <button 
              onClick={() => removeMessage(message.id)}
              className="message-close"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    );
  };

  // Render different pages based on activePage
  const renderPageContent = () => {
    switch (activePage) {
      case 'arrangement':
        return (
          <div className="scene-wrapper">
            <MessageBar />
            
            <div className="panels-wrapper">
              <div className="panel-stack">
                <DeckSize 
                  cargoArea={cargoArea} 
                  setCargoArea={setCargoArea} 
                  isCreated={isCreated}
                  setIsCreated={setIsCreated}
                  cargos={cargos}
                  setCargos={setCargos}
                  onMessage={addMessage}
                />
                <ArrangementParameters 
                  arrangeParameters={arrangeParameters}
                  setArrangeParameters={setArrangeParameters}
                  onMessage={addMessage}
                />
                <CameraManager 
                  camera={camera}
                  controls={controls}
                  onMessage={addMessage}
                />
              </div>
            </div>
                        
            <div className="layer-container">
                <LayerVisibility 
                  cargos={cargos}
                  setCargos={setCargos}
                  cargoArea={cargoArea}
                  arrangeParameters={arrangeParameters}
                  onMessage={addMessage}
                />
            </div>

            <div className="scene-container">
              <ThreeScene
                key={`scene-${isCreated}`} // Add key to force clean re-mount
                cargos={cargos}
                setCargos={setCargos}
                cargoArea={cargoArea}
                setCargoArea={setCargoArea}
                isCreated={isCreated}
                setIsCreated={setIsCreated}
                onMessage={addMessage}
                onCameraReady={handleCameraReady}
                onControlsReady={handleControlsReady}
              />
            </div>
          </div>
        );
      
      case 'overview':
      case 'actions':
      case 'insights':
        return (
          <div className="dashboard-full-page">
            <MessageBar />
            <Dashboard 
              cargos={cargos}
              cargoArea={cargoArea}
              selectedRows={selectedRows}
              onAction={handleDashboardAction}
              activeTab={activePage}
            />
          </div>
        );
      
      default:
        return (
          <div className="scene-wrapper">
            
            <MessageBar />
            <div className="panels-wrapper">
              <div className="panel-stack">
                <DeckSize 
                  cargoArea={cargoArea} 
                  setCargoArea={setCargoArea} 
                  cargos={cargos}
                  setCargos={setCargos}
                  onMessage={addMessage}
                />
                <ArrangementParameters 
                  arrangeParameters={arrangeParameters}
                  setArrangeParameters={setArrangeParameters}
                  onMessage={addMessage}
                />
                Camera Manager 
                <CameraManager 
                  camera={camera}
                  controls={controls}
                  onMessage={addMessage}
                />
              </div>
            </div>

            <div className="layer-container">
                <LayerVisibility 
                  cargos={cargos}
                  setCargos={setCargos}
                  cargoArea={cargoArea}
                  arrangeParameters={arrangeParameters}
                  onMessage={addMessage}
                />
            </div>

            
            <div className="scene-container">
              <ThreeScene
                key={`scene-${isCreated}`} // Add key to force clean re-mount
                cargos={cargos}
                setCargos={setCargos}
                cargoArea={cargoArea}
                setCargoArea={setCargoArea}
                onMessage={addMessage}
                onCameraReady={handleCameraReady}
                onControlsReady={handleControlsReady}
              />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="deck-container">
      <div className="deck-header">
        <DeckHeader 
          activePage={activePage}
          onPageChange={handlePageChange}
        />
      </div>
      
      {renderPageContent()}
      
      {activePage === 'arrangement' && (
        <div className="deck-table-section">
          <DeckTable 
            cargos={cargos}
            setCargos={setCargos}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            cargoArea={cargoArea}
            arrangeParameters={arrangeParameters}
            onMessage={addMessage}
          />
        </div>
      )}
    </div>
  );
}

export default Deck;